import React from 'react';
import { Input } from '../../../ui/Input/Input';
import { cn } from '@hero/web-lib';

export interface IconInputProps extends React.ComponentProps<'input'> {
  /** Icon to render at the leading edge of the input. */
  icon: React.ReactNode;
  /** Optional className override on the inner Input. */
  inputClassName?: string;
}

/**
 * `Input` with a leading-icon adornment. Local to the SignUpWizard
 * because the shared `Input` doesn't (yet) support a leading slot —
 * once it does, this can collapse into the prop.
 *
 * The icon is positioned with `start-3` (logical, RTL-safe) so the
 * Arabic flow flips the icon to the right edge automatically. The
 * input adds `ps-10` to leave room for the glyph.
 */
export const IconInput = React.forwardRef<HTMLInputElement, IconInputProps>(
  ({ icon, inputClassName, className, ...rest }, ref) => {
    return (
      <div className={cn('relative', className)}>
        <span
          className="pointer-events-none absolute start-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          aria-hidden>
          {icon}
        </span>
        <Input ref={ref} className={cn('ps-10', inputClassName)} {...rest} />
      </div>
    );
  },
);
IconInput.displayName = 'IconInput';
